var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCicleChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8241 5.11196C15.0282 5.28609 15.0592 5.60099 14.8934 5.81531L8.70291 13.8153C8.61195 13.9328 8.47517 14.0007 8.33093 14C8.18669 13.9992 8.05058 13.9298 7.96074 13.8113L5.10361 10.0419C4.93985 9.8258 4.9739 9.51125 5.17968 9.33928C5.38544 9.16733 5.68504 9.20308 5.8488 9.41915L8.33717 12.7021L14.1542 5.18472C14.3201 4.9704 14.62 4.93783 14.8241 5.11196Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCicleChecked);
export default __webpack_public_path__ + "static/media/cicle-checked.9be5998947a25727b6de3ed6356bf8f1.svg";
export { ForwardRef as ReactComponent };